import { render } from "./ReportesCatering.vue?vue&type=template&id=7f3d4777&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ReportesCatering.vue?vue&type=script&lang=js"
export * from "./ReportesCatering.vue?vue&type=script&lang=js"

import "./ReportesCatering.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script